module.exports = __webpack_public_path__ + "static/media/tic.05c9d0fa.svg";